import {IBooking, IPosition} from "shared-types/SharedTypes";


export interface IFastBookingCard {
  bookings: IBooking[];
  position: IPosition;
  tableOverlayStatus: FloorplanTableOverlayStatus;
}

export enum FloorplanTableOverlayStatus {
  Conflict = 'Conflict',
  Normal = 'Normal',
  Shared = 'Shared',
}
